import React from 'react';
import styled, { css } from 'styled-components';
import { minBreakpointQuery, sectionMargins } from '../styles';
import { Container, Heading, IconPoints } from './ui';

const StyledFeaturedIconPoints = styled.section`
  ${sectionMargins()};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;

  ${minBreakpointQuery.small`
    margin-bottom: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 30px;
  `}
`;

const StyledItems = styled(IconPoints)`
  ${minBreakpointQuery.tiny`
    column-count: 2;
    column-gap: 20px;
  `}

  ${minBreakpointQuery.medium`
    column-count: 3;
  `}

  ${({ altTheme }) => {
    if (altTheme) {
      return css`
        filter: brightness(0) invert(1);
      `;
    }
  }}
`;

const FeaturedIconPoints = ({ heading, items, altTheme }) =>
  items &&
  items.length > 0 && (
    <StyledFeaturedIconPoints>
      <Container narrow={true}>
        <StyledHeading>{heading}</StyledHeading>
        <StyledItems items={items} altTheme={altTheme} />
      </Container>
    </StyledFeaturedIconPoints>
  );

export default FeaturedIconPoints;
